import { render, staticRenderFns } from "./GrowthMobile.vue?vue&type=template&id=044c2d99&scoped=true&"
import script from "./GrowthMobile.vue?vue&type=script&lang=js&"
export * from "./GrowthMobile.vue?vue&type=script&lang=js&"
import style0 from "./GrowthMobile.vue?vue&type=style&index=0&id=044c2d99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c2d99",
  null
  
)

export default component.exports